import axios from "axios";
import Cookies from "universal-cookie";
import { message } from "antd";

import { KeysToCamel, KeysToSnake } from "scripts/helpers";
import Resources from "./resources";

const _cookies = new Cookies();
const _cookiePath =
	process.env.NODE_ENV === "production"
		? process.env.REACT_APP_COOKIE_PATH
		: "localhost";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.headers.common["Authorization"] = `Bearer ${
	_cookies.get(process.env.REACT_APP_COOKIE_TOKEN) || ""
}`;
//axios.defaults.headers.common['Access-Control-Allow-Credentials'] = true;
//axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

const delCookie = (name) => {
	_cookies.remove(name, {
		path: "/",
		domain: _cookiePath,
	});

	if (name === process.env.REACT_APP_COOKIE_TOKEN)
		axios.defaults.headers.common["Authorization"] = "";
};

const getCookie = (name) => {
	return _cookies.get(name, {
		path: "/",
		domain: _cookiePath,
	});
};

const setCookie = (name, value, expire) => {
	const date = new Date(expire ? undefined : 2147483647 * 1000);

	if (expire) date.setDate(date.getDate() + expire);

	_cookies.set(name, value, {
		path: "/",
		expires: date,
		domain: _cookiePath,
	});

	if (name === process.env.REACT_APP_COOKIE_TOKEN)
		axios.defaults.headers.common["Authorization"] = `Bearer ${value}`;
};

const handleError = (response) => {
	if (response.data?.message) message.error(response.data.message);

	switch (response.status) {
		case 400:
			if (response.data?.errors)
				response.data?.errors.forEach((o) => message.error(o.message));
			break;
		case 403:
			break;
		case 404:
			break;
		case 422:
			break;
		case 500:
			break;
		default:
			delCookie(process.env.REACT_APP_COOKIE_TOKEN);
			break;
	}
};

const get = (url, params = {}, showMessage = true) => {
	return new Promise((resolve, reject) => {
		axios
			.get(url, { params: KeysToSnake(params), validateStatus: false })
			.then((response) => {
				if (response.status === 200) {
					resolve(KeysToCamel(response.data));
				} else {
					showMessage && handleError(response);
					reject(response.data);
				}
			});
	});
};

const post = (url, params = {}, showMessage = true) => {
	return new Promise((resolve, reject) => {
		axios
			.post(url, KeysToSnake(params), { validateStatus: false })
			.then((response) => {
				if (response.status === 200) {
					if (response.data.message) message.success(response.data.message);
					resolve(KeysToCamel(response.data));
				} else {
					showMessage && handleError(response);
					reject(response.data);
				}
			});
	});
};

const put = (url, params = {}, showMessage = true) => {
	return new Promise((resolve, reject) => {
		axios
			.put(url, KeysToSnake(params), { validateStatus: false })
			.then((response) => {
				if (response.status === 200) {
					if (response.data.message) message.success(response.data.message);
					resolve(KeysToCamel(response.data));
				} else {
					showMessage && handleError(response);
					reject(response.data);
				}
			});
	});
};

const del = (url, params = {}, showMessage = true) => {
	return new Promise((resolve, reject) => {
		axios
			.delete(url, { params: KeysToSnake(params), validateStatus: false })
			.then((response) => {
				if (response.status === 200) {
					if (response.data.message) message.success(response.data.message);
					resolve(KeysToCamel(response.data));
				} else {
					showMessage && handleError(response);
					reject(response.data);
				}
			});
	});
};

const upload = (url, params = {}, progress) => {
	return new Promise((resolve, reject) => {
		axios
			.post(url, params, {
				validateStatus: false,
				headers: { "Content-Type": "multipart/form-data" },
				onUploadProgress: (e) => {
					if (progress) progress(Math.floor((e.loaded / e.total) * 100));
				},
			})
			.then((response) => {
				if (response.status === 200) {
					if (response.data.message) message.success(response.data.message);
					resolve(KeysToCamel(response.data));
				} else {
					handleError(response);
					reject(response.data);
				}
			});
	});
};

export default {
	about: () => {
		return get("app/about-us");
	},

	cities: (id, params) => {
		return get(`region/provinces/${id}/cities`, params);
	},
	contact: () => {
		return get("app/contact-us");
	},
	faq: (params) => {
		return get("app/faqs", params);
	},
	provinces: (params) => {
		return get("region/provinces", params);
	},
	settings: () => {
		return get("app/settings");
	},
	support: (params) => {
		return post("app/support-messages", params);
	},
	terms: () => {
		return get("app/tac");
	},

	banner: {
		list: (params) => {
			return get("app/banners", params);
		},
		select: (id) => {
			return get(`app/banners/${id}`);
		},
	},

	auth: {
		me: () => {
			return get("auth/me", {}, false);
		},
		getOtp: (params) => {
			return post("auth/get-otp", params);
		},
		login: (params) => {
			return post("auth/login-password", params);
		},
		logout: () => {
			return get("auth/logout", {}, false);
		},
		register: (params) => {
			return post("auth/register", params);
		},
		reset: (params) => {
			return post("auth/pass-reset", params);
		},
		status: (params) => {
			return post("auth/phone-status", params);
		},
		verify: (params) => {
			return post("auth/phone-verify", params);
		},
	},
	category: {
		list: (params) => {
			return get("app/categories", params);
		},
		select: (id) => {
			return get(`app/categories/${id}`);
		},
	},
	job: {
		bookmark: (id) => {
			return get(`app/jobs/${id}/bookmark`);
		},
		create: (params) => {
			return post("app/jobs", params);
		},
		delete: (id) => {
			return del(`app/jobs/${id}/delete`);
		},
		list: (params) => {
			return get("app/jobs", params);
		},
		rate: (id, params) => {
			return put(`app/jobs/${id}/rate`, params);
		},
		select: (id) => {
			return get(`app/jobs/${id}`);
		},
		special: (params) => {
			return get("app/special-jobs", params);
		},
		status: (id) => {
			return get(`app/jobs/${id}/publication-status`);
		},
		update: (id, params) => {
			return put(`app/jobs/${id}`, params);
		},
	},
	notification: {
		list: (params) => {
			return get("app/notifications", params);
		},
		select: (id) => {
			return get(`app/notifications/${id}`);
		},
	},
	payment: {
		create: (params) => {
			return post("app/payment-confirmations", params);
		},
		list: (params) => {
			return get("app/payment-confirmations", params);
		},
		select: (id) => {
			return get(`app/payment-confirmations/${id}`);
		},
		update: (id, params) => {
			return put(`app/payment-confirmations/${id}`, params);
		},
	},
	profile: {
		bookmarkedJobs: (params) => {
			return get("app/user/bookmarked-jobs", params);
		},
		myJobs: (params) => {
			return get("app/user/my-jobs", params);
		},
		update: (params) => {
			return put("app/user", params);
		},
		updatePass: (params) => {
			return put("app/user/pass-update", params);
		},
	},
	subscription: {
		list: (params) => {
			return get("app/subscriptions", params);
		},
		select: (id) => {
			return get(`app/subscriptions/${id}`);
		},
	},
	transactions: {
		list: (params) => {
			return new Promise((resolve) => {
				setTimeout(() => {
					resolve(KeysToCamel(Resources._transactions));
				}, 1000);
			});
			//return get("app/transactions", params);
		},
		select: (id) => {
			return get(`app/transactions/${id}`);
		},
	},

	delCookie,
	getCookie,
	setCookie,
	upload,
};
